import axios from 'axios'

export const api = axios.create({
  baseURL: '', // Usar rutas relativas sin prefijo extra
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
})

// Request interceptor para agregar JWT token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Response interceptor para manejo de errores
let authErrorCount = 0

api.interceptors.response.use(
  (response) => {
    authErrorCount = 0 // Reset en respuesta exitosa
    return response
  },
  (error) => {
    const status = error.response?.status
    const url = error.config?.url || ''

    // Solo logout en 401/403 de endpoints de autenticación o tras 2 fallos consecutivos
    if (status === 401 || (status === 403 && !error.response?.data?.requires_terms)) {
      // Ignorar errores de endpoints públicos o analytics
      const isPublicEndpoint = url.includes('/analytics') || url.includes('/announcements')
      if (isPublicEndpoint) {
        return Promise.reject(error)
      }

      authErrorCount++

      if (authErrorCount >= 2) {
        authErrorCount = 0
        localStorage.removeItem('token')
        localStorage.removeItem('agent')

        const message = document.createElement('div')
        message.textContent = '⚠️ Sesión expirada. Redirigiendo al login...'
        message.style.cssText = `
          position: fixed;
          top: 20px;
          right: 20px;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          color: white;
          padding: 16px 24px;
          border-radius: 12px;
          box-shadow: 0 10px 25px rgba(0,0,0,0.3);
          z-index: 9999;
          font-family: system-ui, -apple-system, sans-serif;
          font-weight: 500;
        `
        document.body.appendChild(message)
        setTimeout(() => {
          message.remove()
          window.location.href = '/login'
        }, 2000)
      }
    }

    console.error('API Error:', error.response?.data || error.message)
    return Promise.reject(error)
  }
)

export default api
